import { type OfferV11 } from '@redteclab/api/clients/bully'

export const productAccessorOfferHasPromotionSetOfferFlag = (
  offer: OfferV11,
): boolean => {
  return Boolean(
    offer.offerFlags?.find((flag) => {
      return flag === 'isPromotionSet'
    }),
  )
}
